import { STATES } from 'common/domain/states';
import { LOANS, LOANS_MODAL_STATES } from '../../../common/domain/constants.loans.js';
import { MODALS } from 'common/domain/constants';
import _ from 'lodash';

class LoansSignUpResumeController {

  constructor($state, GoBackDataService, mainMenuMobileBehaviourService) {
    'ngInject';
    this.state = $state;
    this.hideButtonCadastral = false;
    this.goBackDataService = GoBackDataService;
    this.mainMenuMobileBehaviourService = mainMenuMobileBehaviourService;
  }

  $onInit() {
    this.salaryToShow = this.shouldSalaryToShow(this.loan);

    if (this.isMobileApp) {
      this.floatingActionButtonsHousingLoan = this._getFloatingActionButtonsHousingLoan();
      this.floatingActionButtonsSuccess = this._getFloatingActionButtonsSuccess();
      this.floatingActionButtonsError = this._getFloatingActionButtonsError();
      this.mainMenuMobileBehaviourService.setCustomBehaviour(() => {
        const from = this.goBackDataService.getDataBackToSignUp().from;
        this.state.go(from);
      });

      this.hideButtonCadastral = this.goBackDataService.getHideOrShowButtonCadastralSignUp();
    }
  }

  $onDestroy() {
    this.goBackDataService.setDataBackToSignUp({});
    this.goBackDataService.setHideOrShowButtonCadastralSignUp(undefined);
  }

  get modal() {
    return $(MODALS.MY_LOANS).modal({backdrop: 'static', keyboard: false});
  }

  shouldSalaryToShow (loan) {
    return loan.id === LOANS.ID.FIVE_MONTH || loan.id === LOANS.ID.NINE_MONTH;
  }

  goToMyLoans() {
    this.state.go(STATES.LOANS.MY_LOANS);
  }

  openModal() {
    this.optionModalIsSelected = LOANS_MODAL_STATES.CADASTRAL_REFERENCE;
    if (this.isMobileApp) {
      this.loan.identifying = this.loanResponseId;
      const paramsSignUp = this.goBackDataService.getDataBackToSignUp();
      const dataParams = {
        loan: this.loan,
        simulation: this.simulation,
        from: 'sign-up',
        paramsSignUp: paramsSignUp
      };
      this.state.go(STATES.LOANS.CADASTRAL_REFERENCE, {dataParams});
    } else {
      this.modal.modal('show');
    }
  }

  onSave($event) {
    this.modal.modal('hide');
    this.errorCadastral = $event.error;
    this.messageError = $event.messageError;
    $(MODALS.REQUEST_CADASTRAL).modal('show');
  }

  isHousingLoan() {
    let housingLoan = this.loan.id === LOANS.ID.AGREEMENT_HOUSING_LOAN || this.loan.id === LOANS.ID.SOCIAL_HOUSING_LOAN;
    return this.success && housingLoan;
  }

  onCloseModalCadastral() {
    $(MODALS.REQUEST_CADASTRAL).modal('hide');
    if (this.errorCadastral === 'failed') {
      this.modal.modal('show');
    } else {
      this.hideButtonCadastral = true;
    }
  }

  closeModalCadastral($event) {
    if (!$event.isCadastralCorrect) {

      if (!_.isEmpty($event.cadastralReference)) {
        this.cadastralReferenceBackup = angular.copy($event.cadastralReference);
        this.tempLoanObject = $event.cadastralReference;
      } else {
        this.tempLoanObject = angular.copy(this.cadastralReferenceBackup);
      }

    } else {
      this.tempLoanObject = {};
    }

    this.optionModalIsSelected = LOANS_MODAL_STATES.CLOSE_CADASTRAL_REFERENCE;
  }

  resetFormCadastral() {
    this.tempLoanObject = {};
  }

  showCadastralReference() {
    this.optionModalIsSelected = LOANS_MODAL_STATES.CADASTRAL_REFERENCE;
  }

  _getFloatingActionButtonsHousingLoan() {
    return [
      {
        literal: 'LOANS.SIGN_UP.CADASTRAL_REFERENCE_SHORT'
      }, {
        literal: 'LOANS.SIGN_UP.TO_MY_LOANS'
      }
    ];
  }

  _getFloatingActionButtonsSuccess() {
    return [
      {
        literal: 'LOANS.SIGN_UP.TO_MY_LOANS'
      }
    ];
  }

  _getFloatingActionButtonsError() {
    return [
      {
        literal: 'LOANS.SIGN_UP.ACCEPT'
      }
    ];
  }
}

export default LoansSignUpResumeController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansSignUp/loansSignUpResume/loansSignUpResume.controller.js